module.exports = __webpack_public_path__ + "static/media/2.8fefa2a6.jpg";